// @ts-nocheck
import React, {useState} from 'react';
import {Platform, View} from 'react-native';
import {useStyles} from '../../../shared/hooks/styles';
import {DeviceSize} from '../../../shared/theme/helpers';
import {LoadableContent} from '../../../shared/components/loadableContent';
import {CustomScrollView} from '../../../shared/components/scrollView';
import {Button} from '../../../shared/components/button';
import {Text} from '../../../shared/components/text';

import {BaseFieldWrapper} from '../../../shared/components/baseField';
import {useIsDesktop} from '../../../shared/hooks/useIsDesktop';
import {useDispatch, useSelector} from 'react-redux';
import {esiaSendActivateCard, esiaSendActivateCardAfterLogged, logout} from '../../../redux/actions/login';
import {ServerValidationError} from '../../../shared/models/serverValidationError';
import {addNotification} from '../../../redux/actions/snackbar';
import {SnackbarNotificationType} from '../../../shared/components/snackbar/model';
import {esiaRegistrationInfoSelector, esiaUserHasNoCardsSelector} from '../../../redux/selectors/login';
import {useMap} from '../esiaRegCard/components/map/useMap';
import {initialYandexZoomValue} from '../esiaRegCard/components/map/models';
import {useTheme} from '../../../shared/theme';
import {images} from '../../../assets/icons';
import {Link} from '../../../shared/components/link';
import {formatPhone, formatPhoneToCallable} from '../../../shared/pipes';
import {Clusterer, Placemark, YMaps, Map} from 'react-yandex-maps';
import MapMarker from '../../../assets/icons/map-marker.svg';
import MapPin from '../../../assets/icons/map-pin.svg';
import {DeliveryType} from '../../../types/registerCardApplicationRequestPayload';
import {CardApplicationStatus} from '../../../types/enums/cardApplicationStatus';
import {CardStatus} from '../../../types/enums/cardStatus';
import {StorageKeys, storage} from '../../../shared/storage';
import {GetIssuePointCabinetResponsePayload} from '../../../shared/models/api/getIssuePointCabinetResponsePayload';
import {ExternalLink} from '../../../shared/components/externalLink';
import {loginStepSlice} from '../../../redux/reducers/runtime/loginStep';
import {LoginState} from '../../../shared/models/login/loginStep';
import {loginSlice} from '../../../redux/reducers/login';
import {profileSlice} from '../../../redux/reducers/profile';
import {QrCodeIcon} from '../components/qrCodeIcon';
import {useAccountLinker} from '../../../shared/hooks/useAccountLinkerHook/useAccountLinker';
import {CounterpartyLinkedProfile} from '../../../shared/hooks/useAccountLinkerHook/Types';
import {AuthorizeEsiaResponsePayload} from '../../../shared/models/api/authorizeEsiaResponsePayload';
import {holderProfileSelector} from '../../../redux/selectors/profile';
import {useIsSmallScreenDevice} from '../../../shared/hooks/useIsSmallScreenDevice';

type CardApplicationStatusDescribed = Record<keyof typeof CardApplicationStatus, string> & {[key: string]: string};
type CardStatusDescribed = Record<keyof typeof CardStatus, string> & {[key: string]: string};

const cardApplicationsStatuses: CardApplicationStatusDescribed = {
  Created: 'Принято',
  OnReview: 'На рассмотрении',
  Accepted: 'Одобрено',
  Declined: 'Отказано',
};

const cardStatuses: CardStatusDescribed = {
  New: 'Выпущена',
  Active: 'Активная',
  Blocked: 'Заблокирована',
  Returned: 'Возвращена клиентом',
  InDelivery: 'В доставке',
  Arrived: 'Прибыло в место вручения',
  Reserved: 'Зарезервирована',
};

const russianPostTrackingUrl = 'https://www.pochta.ru/tracking?barcode=';

export default ({onCloseModal, linkedAccountIdWeb}: {onCloseModal?(): void; linkedAccountIdWeb?: number}) => {
  const theme = useTheme();
  const isDesktop = useIsDesktop();
  const isSmallScreen = useIsSmallScreenDevice();
  const styles = useStyles(({mediaOnly, addShadow}) => {
    return {
      formSubmitBox: {
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: 20,
        marginTop: 0,
        width: '100%',
      },
      form: {
        marginTop: 20,
        ...mediaOnly(DeviceSize.mobile, {marginTop: 0, marginBottom: 24, alignItems: 'center'}),
      },
      formSubmit: {
        paddingHorizontal: isSmallScreen ? 0 : 20,
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      },
      btnContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignContent: 'center',
        justifyContent: 'center',
        width: '100%',
      },
      submit: {
        display: 'flex',
        flexDirection: 'column',
        alignContent: 'center',
        justifyContent: 'center',
        marginTop: 14,
        width: isDesktop ? '50%' : 260,
        zIndex: 3,
      },
      checkbox: {
        flexDirection: 'row',
        alignItems: 'flex-start',
        justifyContent: 'center',
        ...mediaOnly(DeviceSize.desktop, {width: '100%'}),
        ...mediaOnly(DeviceSize.tablet, {width: 560}),
        ...mediaOnly(DeviceSize.mobile, {width: 260}),
      },
      checkboxBtn: {
        marginRight: 12,
      },
      agreement: {
        ...mediaOnly(DeviceSize.desktop, {}, {flex: 1}),
        flexDirection: 'row',
        alignItems: 'center',
        flexWrap: 'wrap',
      },
      agreementText: {
        ...mediaOnly(DeviceSize.desktop, theme.fonts.body, {...theme.fonts.bodySmallLight, lineHeight: 24}),
      },
      agreementTextDoc: {
        color: theme.color.primaryColor,
      },
      deliveryInfoContainer: {
        width: '100%',
        marginTop: isDesktop ? 0 : 24,
        paddingHorizontal: 14,
        position: 'relative',
      },
      subtitle: {
        textAlign: 'center',
        marginTop: 10,
        marginBottom: 10,
        position: 'relative',
        ...(Platform.OS === 'ios' && {paddingHorizontal: 14}),
      },
      showTable: {
        transform: [{translateY: 0}],
      },
      hideTable: {
        transform: [{translateY: -250}],
      },
      mapBlock: {
        ...mediaOnly(DeviceSize.desktop, {marginTop: 24}),
        width: '100%',
        borderRadius: 5,
        ...addShadow({height: 2, radius: 18, opacity: 0.1}),
        ...mediaOnly(DeviceSize.mobile, {maxWidth: 400}),
      },
      mapWrapper: {
        height: 300,
        ...mediaOnly(DeviceSize.mobile, {height: 380, paddingHorizontal: 20}),
      },
      table: {
        display: 'flex',
        padding: 24,
        paddingTop: 0,
        flexDirection: 'row',
        backgroundColor: theme.color.backgroundMenuColor,
        ...mediaOnly(DeviceSize.mobile, {
          flexDirection: 'column',
          maxHeight: '100%',
          paddingBottom: 0,
          paddingTop: 0,
        }),
      },
      firstColumn: {
        marginRight: 20,
        ...mediaOnly(DeviceSize.mobile, {flexDirection: 'column', marginTop: 24}, {width: '50%'}),
      },
      secondColumn: {
        ...mediaOnly(DeviceSize.mobile, {flexDirection: 'column', marginTop: 24}, {width: '50%'}),
      },
      row: {
        marginBottom: 20,
      },
      rowWithIcon: {
        flexDirection: 'row',
        maxWidth: '100%',
      },
      icon: {
        marginRight: 12,
        color: theme.color.primaryColor,
        justifyContent: 'center',
        height: 30,
      },
      map: {
        width: '100%',
        height: '100%',
      },
      groupItem: {
        flexDirection: 'row',
        alignItems: 'flex-start',
        marginBottom: 12,
        paddingVertical: 5,
      },
      cluster: {
        color: theme.color.primaryColor,
      },
      clusterText: {
        color: theme.color.labelText,
      },
      issuePointInfoContainer: {
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        width: '100%',
        paddingHorizontal: 16,
      },
      issuePointInfoText: {
        flexShrink: 1,
      },
      trackingNumberLink: {
        color: theme.color.linkColor,
      },
    };
  });

  const dispatch = useDispatch();
  const userHasNoCards = useSelector(esiaUserHasNoCardsSelector);
  let esiaRegInfo: CounterpartyLinkedProfile | AuthorizeEsiaResponsePayload | null | undefined;
  const esiaRegInfoFromSelector = useSelector(esiaRegistrationInfoSelector);
  const {linkedAccounts, loadLinkedAccountsInfo} = useAccountLinker();
  const profile = useSelector(holderProfileSelector());
  const isLogged = !!profile;

  if (linkedAccountIdWeb != null) {
    esiaRegInfo = linkedAccounts.find((acc) => acc.id === linkedAccountIdWeb);
  } else {
    esiaRegInfo = esiaRegInfoFromSelector;
  }

  const [loading, setLoading] = useState(false);
  const [cardNumberToActivate, setCardNumberToActivate] = useState<string>('');

  const onActivateCardClick = async (event?: any) => {
    event?.preventDefault();
    if (isLogged) {
      try {
        setLoading(true);
        await dispatch(
          esiaSendActivateCardAfterLogged({CardNumber: cardNumberToActivate, CounterpartyLinkId: linkedAccountIdWeb}),
        );
        await loadLinkedAccountsInfo();
        if (onCloseModal) onCloseModal();
      } catch (e) {
        const error = e as ServerValidationError;
        let errorText = error.data?.[0].message || error.message || 'Ошибка. Повторите еще раз';
        dispatch(
          addNotification({
            message: errorText,
            type: SnackbarNotificationType.Error,
          }),
        );
      } finally {
        setLoading(false);
      }
      return;
    }
    try {
      setLoading(true);
      const token = await storage.getItem(StorageKeys.activationToken);
      await dispatch(esiaSendActivateCard({CardNumber: cardNumberToActivate}));
      await storage.setItem(StorageKeys.token, token);
      await storage.removeItem(StorageKeys.activationToken);
      if (Platform.OS === 'web') window.location.reload();
      else {
        await dispatch(loginSlice.actions.setEsiaUserHasNoCards(false));
        await dispatch(profileSlice.actions.setToken(token));
      }
    } catch (e) {
      const error = e as ServerValidationError;
      let errorText = error.data?.[0].message || error.message || 'Ошибка. Повторите еще раз';
      dispatch(
        addNotification({
          message: errorText,
          type: SnackbarNotificationType.Error,
        }),
      );
    } finally {
      setLoading(false);
    }
  };

  const mapInstance = React.useRef<any>(null);
  const [mapZoomLevel, setMapZoomLevel] = React.useState(initialYandexZoomValue);
  const {mapData, mapDataRaw, onPressMarker, currentMarker, centerPoint} = useMap();
  const [mapCenterPoint, setMapCenterPoint] = React.useState<number[]>([0, 0]);
  const selectedIssuePoint = React.useMemo<GetIssuePointCabinetResponsePayload>(
    () => mapDataRaw.find((x) => x.id === esiaRegInfo?.cardDeliveryInfo?.counterpartyDepartmentId),
    [mapDataRaw, esiaRegInfo?.cardDeliveryInfo?.counterpartyDepartmentId],
  );

  const handleMapInstanceChange = React.useCallback(
    (instance) => {
      mapInstance.current = instance;
      if (instance && mapData) {
        if (userHasNoCards) {
          const targetIssuePoint = mapData.find(
            (x) => x.id === esiaRegInfo?.cardDeliveryInfo?.counterpartyDepartmentId,
          );
          if (targetIssuePoint?.geolocation?.length > 1) targetIssuePoint.geolocation = targetIssuePoint.geolocation;
          if (targetIssuePoint) {
            onPressMarker(targetIssuePoint);
            setMapZoomLevel(15);
            if (targetIssuePoint.geolocation?.length === 2) setMapCenterPoint(targetIssuePoint.geolocation.flat());
            return;
          }
        }
        if (centerPoint) setMapCenterPoint(centerPoint);
      }
    },
    [mapData, mapInstance, userHasNoCards],
  );

  function onOrderFormClose(): void {
    dispatch(logout());
    dispatch(loginStepSlice.actions.setLoginStep(LoginState.enter));
    onCloseModal?.();
  }

  return (
    <LoadableContent loading={loading}>
      {!loading ? (
        <CustomScrollView
          contentContainerStyle={styles.formSubmitBox}
          scrollEnabled={true}
          withRefresh={false}
          contentInsetAdjustmentBehavior='automatic'>
          <View style={styles.form}>
            {esiaRegInfo?.cardDeliveryInfo?.deliveryTypeId === DeliveryType.RussianPost ? (
              <View style={styles.deliveryInfoContainer}>
                <Text type='h6Light' style={styles.subtitle}>
                  Статус заявления:{' '}
                  {esiaRegInfo.cardApplicationStatusId != null
                    ? cardApplicationsStatuses[CardApplicationStatus[esiaRegInfo.cardApplicationStatusId]]
                    : cardApplicationsStatuses.Created}
                </Text>
                {esiaRegInfo.cardStatusId != null && (
                  <Text type='h6Light' style={styles.subtitle}>
                    Статус карты: {cardStatuses[CardStatus[esiaRegInfo.cardStatusId]]}
                  </Text>
                )}
                <Text type='h6Light' style={styles.subtitle}>
                  Адрес получателя: {esiaRegInfo.cardDeliveryInfo.desiredAddress}
                </Text>
                {esiaRegInfo.cardDeliveryInfo?.trackingNumber != null && (
                  <Text type='h6Light' style={styles.subtitle}>
                    Трек-номер (Почта России):{' '}
                    {Platform.OS === 'web' ? (
                      <a href={russianPostTrackingUrl + esiaRegInfo.cardDeliveryInfo?.trackingNumber} target='_blank'>
                        {esiaRegInfo.cardDeliveryInfo?.trackingNumber}
                      </a>
                    ) : (
                      <ExternalLink
                        testID='trackingNumber'
                        style={styles.trackingNumberLink}
                        link={russianPostTrackingUrl + esiaRegInfo.cardDeliveryInfo?.trackingNumber}
                        text={esiaRegInfo.cardDeliveryInfo?.trackingNumber}
                      />
                    )}
                  </Text>
                )}
              </View>
            ) : (
              <>
                <Text type={isDesktop ? 'h3Light' : 'h6Light'} style={styles.subtitle}>
                  Карта готова к выдаче. Обратитесь в пункт выдачи нефинансовой карты. При себе необходимо иметь
                  документы, удостоверяющие личность.
                </Text>
                {Platform.OS !== 'web' && selectedIssuePoint != null && (
                  <View style={styles.issuePointInfoContainer}>
                    <Text style={styles.row} type='h6'>
                      Отделение {selectedIssuePoint.name ?? selectedIssuePoint.organization?.name}
                    </Text>
                    <View style={[styles.row, styles.rowWithIcon]}>
                      <View style={styles.icon}>
                        <images.Location width={24} height={24} color={theme.color.primaryColor} />
                      </View>
                      <Text style={styles.issuePointInfoText} type='h6Light'>
                        {selectedIssuePoint.address}
                      </Text>
                    </View>
                    <View style={styles.rowWithIcon}>
                      <Link
                        testID='phone-geo-map-link-id'
                        href={`tel:${formatPhoneToCallable(selectedIssuePoint.phone)}`}
                        external
                        style={styles.groupItem}>
                        <View style={styles.icon}>
                          <images.Phone width={24} height={24} color={theme.color.primaryColor} />
                        </View>
                        <Text style={styles.issuePointInfoText} type='h6Light'>
                          {formatPhone(selectedIssuePoint.phone)}
                        </Text>
                      </Link>
                    </View>
                    <Text style={styles.row} type='h6'>
                      Часы работы
                    </Text>
                    <View style={styles.rowWithIcon}>
                      <View style={styles.icon}>
                        <images.Clock2 width={24} height={24} color={theme.color.primaryColor} />
                      </View>
                      <Text style={styles.issuePointInfoText} type='h6Light'>
                        {selectedIssuePoint.operatingMode}
                      </Text>
                    </View>
                  </View>
                )}
              </>
            )}
            {esiaRegInfo?.cardDeliveryInfo?.deliveryTypeId === DeliveryType.IssuePoint &&
              selectedIssuePoint &&
              Platform.OS === 'web' && (
                <View style={styles.mapBlock}>
                  <View style={styles.form}>
                    <View style={styles.table}>
                      <View style={[styles.firstColumn]}>
                        <Text style={[styles.row]} type='h6'>
                          Отделение {selectedIssuePoint.name ?? selectedIssuePoint.organization?.name}
                        </Text>
                        <View style={[styles.row, styles.rowWithIcon]}>
                          <View style={styles.icon}>
                            <images.Location width={24} height={24} color={theme.color.primaryColor} />
                          </View>
                          <Text type='h6Light'>{selectedIssuePoint?.address}</Text>
                        </View>
                        <View style={styles.rowWithIcon}>
                          <View style={styles.icon}>
                            <images.Phone width={24} height={24} color={theme.color.primaryColor} />
                          </View>
                          <Text type='h6Light'>{selectedIssuePoint?.phone}</Text>
                        </View>
                      </View>
                      <View style={[styles.secondColumn]}>
                        <Text style={[styles.row, styles.rowWithIcon]} type='h6'>
                          Часы работы
                        </Text>
                        <View style={[styles.row, styles.rowWithIcon]}>
                          <View style={styles.icon}>
                            <images.Clock2 width={24} height={24} color={theme.color.primaryColor} />
                          </View>
                          <Text type='h6Light'>{selectedIssuePoint?.operatingMode}</Text>
                        </View>
                      </View>
                    </View>
                  </View>
                  {linkedAccountIdWeb == null && selectedIssuePoint.geolocation?.length > 1 && (
                    <View style={styles.mapWrapper}>
                      <YMaps>
                        <Map
                          instanceRef={handleMapInstanceChange}
                          options={{autoFitToViewport: 'always'}}
                          height='100%'
                          width='100%'
                          state={{zoom: mapZoomLevel, center: mapCenterPoint}}
                          defaultState={{center: mapCenterPoint, zoom: mapZoomLevel}}>
                          <Clusterer options={{preset: 'islands#invertedOrangeClusterIcons'}}>
                            <Placemark
                              key={selectedIssuePoint.id}
                              geometry={selectedIssuePoint.geolocation}
                              options={{
                                iconLayout: 'default#image',
                                iconImageHref: MapPin,
                                iconImageSize: [60, 60],
                                iconImageOffset: [-30, -60],
                              }}
                            />
                          </Clusterer>
                        </Map>
                      </YMaps>
                    </View>
                  )}
                </View>
              )}

            <View testID='styles.formSubmitBtnContainer' style={styles.formSubmit}>
              <BaseFieldWrapper
                onCustomBlur={() => {}}
                input={{
                  value: cardNumberToActivate,
                  onChange: (e) => setCardNumberToActivate(e ?? ''),
                }}
                label={Platform.OS !== 'web' ? 'Номер карты для активации' : 'Укажите номер карты для активации'}
                type='digits'
                autoCapitalize='none'
                name='cardNumToActivate'
                readOnly={false}
                inputContainerStyle={
                  Platform.OS !== 'web' ? {width: Platform.OS === 'ios' ? '90%' : '100%'} : undefined
                }
                style={
                  isDesktop
                    ? {width: '80%', marginBottom: 10, marginTop: 20, maxWidth: '345px', zIndex: 3}
                    : {width: '80%', marginBottom: 0, marginTop: 20, zIndex: 3}
                }
                right={
                  Platform.OS !== 'web' ? <QrCodeIcon onScan={setCardNumberToActivate} adjustFor='input' /> : undefined
                }
              />
              <Button
                style={styles.submit}
                disabled={loading}
                onPress={onActivateCardClick}
                text='Активировать карту'
                id='esia-active-card-form-submit'
              />
              {Platform.OS === 'web' && isDesktop && !isLogged && (
                <Button
                  style={styles.submit}
                  disabled={loading}
                  onPress={onOrderFormClose}
                  text='Выход'
                  id='esia-form-close'
                />
              )}
            </View>
          </View>
        </CustomScrollView>
      ) : null}
    </LoadableContent>
  );
};
